import { render, staticRenderFns } from "./vehicle-detail.vue?vue&type=template&id=230d665e&scoped=true"
import script from "./vehicle-detail.vue?vue&type=script&lang=js"
export * from "./vehicle-detail.vue?vue&type=script&lang=js"
import style0 from "./vehicle-detail.vue?vue&type=style&index=0&id=230d665e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230d665e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('230d665e')) {
      api.createRecord('230d665e', component.options)
    } else {
      api.reload('230d665e', component.options)
    }
    module.hot.accept("./vehicle-detail.vue?vue&type=template&id=230d665e&scoped=true", function () {
      api.rerender('230d665e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/vehicle/components/vehicle-detail.vue"
export default component.exports